var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import Grid from '@material-ui/core/Grid';
import { LinearProgress } from '@material-ui/core';
export default function Loader(_a) {
    var style = _a.style;
    return (React.createElement(Grid, { container: true, justify: 'center', style: __assign({}, style) },
        React.createElement(LinearProgress, { color: "primary", style: { width: '100%' } })));
}
